import React, { useCallback } from 'react';
import {
    setSelectedMixEffect,
} from 'actions/index.js';
import ParameterVisual from './ParameterVisual.js';
import { connect } from "react-redux";
import {
    dragEffect,
    setSelectedEffectOption,
} from 'actions/index.js';
import '../../../Sends.scss';

function EffectOption(props) {
    const onDragOver = (e) => {
        e.preventDefault();
    };

    const onDragStart = useCallback((e) => {
        props.dragEffect({effectNumber: props.effectNumber});
    }, [props.effectNumber]);

    const onDrop = useCallback((e) => {
        e.stopPropagation();
        if (props.effectDragging === undefined) {
            return;
        }
        let {effectNumber} = props.effectDragging;
        props.moveEffectTo(effectNumber, props.effectNumber);
        props.dragEffect(undefined);
    }, [props.effectNumber, props.effectDragging]);

    const selectEffect = useCallback((e) => {
        props.setSelectedEffect(
            props.isSelected ? undefined : props.effect);
    }, [props.isSelected, props.effect]);

    let className = "send-effect";
    if (props.isSelected) {
        className += " selected";
    }

    let parameters = props.effect.getParameters();
    if (parameters.length > 10) {
        parameters = parameters.slice(0, 10);
    }
    if (props.pulledEffects && props.pulledEffects.includes(props.effect)) {
        className += " pulled";
    }
    return (
        <div
          onClick={selectEffect}
          onDragOver={onDragOver}
          onDrop={onDrop}
          onDragStart={onDragStart}
          draggable
          className={className}>
          <div className="effect-name">{props.effect.name}</div>
          {parameters.map(parameter => <ParameterVisual parameter={parameter}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let subId = props.currentSubSequence.id;
    let track = props.track;
    let group = props.group;
    let isSelected = false;
    if (props.effectType === 'AUDIO_FX') { 
        isSelected = track !== undefined ?
            props.effect === (state.mix.selectedTrackEffects[subId] && state.mix.selectedTrackEffects[subId][track.id]) :
            props.effect === (state.mix.selectedGroupEffects[subId] && state.mix.selectedGroupEffects[subId][group.id]) ;

    } else {
        isSelected = 
            props.effect === (state.mix.selectedTrackMidiEffects[subId] && state.mix.selectedTrackMidiEffects[subId][track.id]) ;
    }
    return {
        effectDragging: state.sequencer.effectDragging,
        isSelected,
        pulledEffects: state.effects.pulledEffects
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        dragEffect: (e) => dispatch(dragEffect(e)),
        setSelectedEffect: (effect) => 
            dispatch(
                setSelectedMixEffect(props.currentSubSequence.id, props.track.id, props.group, props.effectType, effect))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectOption);
